document.addEventListener('DOMContentLoaded', () => {
  const endpoint = 'https://sdduubuztedcorotoqmc.supabase.co/functions/v1/search-products';
  const searchPageUrl = '/pages/ai-search';

  const forms = document.querySelectorAll('.custom-header-search__form');

  forms.forEach((form) => {
    const input = form.querySelector('.custom-header-search__input');
    const results = form.querySelector('.ai-search-results');

    if (!input || !results) return;

    let timer;

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const query = input.value.trim();
      if (query.length < 2) return;

      window.location.href = `${searchPageUrl}?q=${encodeURIComponent(query)}`;
    });

    input.addEventListener('input', () => {
      clearTimeout(timer);

      const query = input.value.trim();

      if (query.length < 3) {
        results.innerHTML = '';
        results.classList.remove('is-active');
        return;
      }

      timer = setTimeout(() => previewSearch(query, results), 450);
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) {
        results.innerHTML = '';
        results.classList.remove('is-active');
      }
    });
  });

  async function previewSearch(query, results) {
    results.classList.add('is-active');
    results.innerHTML = '<div class="ai-search-message">Searching...</div>';

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query,
          limit: 5,
          threshold: getThreshold(query)
        })
      });

      const data = await response.json();

      if (!data.results || !data.results.length) {
        results.innerHTML = `
          <div class="ai-search-message">
            No quick matches found.
            <br>
            <a class="ai-search-view-all" href="${searchPageUrl}?q=${encodeURIComponent(query)}">
              Search all products for “${escapeHtml(query)}”
            </a>
          </div>
        `;
        return;
      }

      const productsHtml = data.results.map(renderProduct).join('');

      results.innerHTML = `
        ${productsHtml}
        <a class="ai-search-view-all" href="${searchPageUrl}?q=${encodeURIComponent(query)}">
          View all results for “${escapeHtml(query)}”
        </a>
      `;
    } catch (error) {
      console.error('AI SEARCH ERROR', error);
      results.innerHTML = '<div class="ai-search-message">Search unavailable</div>';
    }
  }

  function getThreshold(query) {
    if (query.length <= 5) return 0.18;
    if (query.split(/\s+/).length === 1) return 0.2;
    return 0.3;
  }

  function renderProduct(product) {
    const title = escapeHtml(product.title || '');
    const handle = escapeHtml(product.handle || '');
    const image = product.featured_image_url && product.featured_image_url !== 'null'
      ? product.featured_image_url
      : '';

    const price = product.price_min
      ? `£${Number(product.price_min).toFixed(2)}`
      : '';

    return `
      <a class="ai-search-item" href="/products/${handle}">
        <div class="ai-search-thumb">
          ${
            image
              ? `<img src="${escapeHtml(image)}" alt="${title}" loading="lazy">`
              : `<div class="ai-search-no-image"></div>`
          }
        </div>

        <div class="ai-search-info">
          <div class="ai-search-title">${title}</div>
          ${price ? `<div class="ai-search-price">${price}</div>` : ''}
        </div>
      </a>
    `;
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
});